import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { INSTANCE_ID_QUERY_PARAM_KEY, LOCAL_STORAGE_INSTANCE_ID_KEY } from '@frontend/utils/misc';

import { useLocalstorageParam } from './useLocalstorageParam';
import { useOpalUser } from './useOpalUser';

const useInstanceId = () => {
  const { opalUser } = useOpalUser();
  const [localInstanceId, setLocalInstanceId] = useLocalstorageParam(LOCAL_STORAGE_INSTANCE_ID_KEY);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const instanceIdInQuery = searchParams.get(INSTANCE_ID_QUERY_PARAM_KEY);
    const locationParts = location.pathname.split('/');
    const instanceIdInPath =
      locationParts.length > 2 && locationParts[1] === 'instances' ? locationParts[2] : null;

    const instanceIdInUrl = instanceIdInQuery || instanceIdInPath;

    if (instanceIdInUrl) {
      if (instanceIdInUrl !== localInstanceId) {
        setLocalInstanceId(instanceIdInUrl);
      }
    }
  }, [searchParams, setLocalInstanceId, localInstanceId, location.pathname]);

  useEffect(() => {
    if (opalUser?.instance?.instance_id && !localInstanceId) {
      setLocalInstanceId(opalUser.instance.instance_id);
    }
  }, [opalUser?.instance?.instance_id, setLocalInstanceId, localInstanceId]);

  return { instanceId: localInstanceId };
};

export { useInstanceId };
